document.addEventListener('DOMContentLoaded', () => {
  const continueButton = document.getElementById('continue-button');

  if (continueButton) {
    continueButton.addEventListener('click', () => {
      // Seleccionamos los elementos necesarios
      const variantPicker = document.querySelector('.f-product-single__block--variant_picker');
      const buyButtons = document.querySelector('.f-product-single__block--buy_buttons');
      const viewDetails = document.querySelector('.btn-view-details');
      
      // Validamos si los elementos existen para evitar errores
      if (variantPicker) {
        variantPicker.classList.add('hide');
      }

      if (buyButtons) {
        buyButtons.style.display = 'block';
      }
      if (viewDetails) {
        viewDetails.style.display = 'none';
      }

      const buttonsAdd = document.querySelectorAll('.product-flow .f-product-form__submit');
      buttonsAdd.forEach(buttonAdd => {
        buttonAdd.removeAttribute('disabled');
        buttonAdd.disabled = false; // Asegura que el botón esté habilitado
      });


    });
  }




  // Script to handle received variables in another file
  function handleReceivedData() {
    const params = new URLSearchParams(window.location.search);
    const fullName = params.get('fullname');
    const dob = params.get('dob');

    if (fullName && dob) {
      const userData = {
        fullName,
        dateOfBirth: dob
      };
      console.log(userData); // You can replace this with any desired action
    }
  }

  // Call the function in the other file
  handleReceivedData();

  //  STEP 2
  //--------------------------------------------------------
  // Add click handler for "go-product" link
  const goProductLink = document.getElementById('go-product');
  if (goProductLink) {
    goProductLink.addEventListener('click', function (e) {
      e.preventDefault();

      const params = new URLSearchParams(window.location.search);
      const fullName = params.get('fullname');
      const dob = params.get('dob');

      if (fullName && dob) {
        const url = `${this.href}?fullname=${encodeURIComponent(fullName)}&dob=${encodeURIComponent(dob)}&view=product-4-year-old`;
        window.location.href = url;
      } else {
        window.location.href = this.href;
      }
    });
  }

  //  STEP 3
  //--------------------------------------------------------
  const params = new URLSearchParams(window.location.search);
  const fullName = params.get('fullname');
  const dob = params.get('dob');

  setTimeout(() => {
    const nameInput = document.querySelector('input[name="Childs Name"]');
    const dobInput = document.querySelector('input[name="DOB"]');

    console.log('dob--' + dob)
    console.log('fullName--' + fullName)

    if (fullName && nameInput) {
    
      nameInput.value = fullName;
      nameInput.dispatchEvent(new Event('input', { bubbles: true }));
      //nameInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    if (dob && dobInput) {
      dobInput.value = dob;
      dobInput.dispatchEvent(new Event('input', { bubbles: true }));
    // dobInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

  }, 700);
  
   
  

  setTimeout(() => {

    const buttons = document.querySelectorAll('.product-flow .f-product-form__submit');
    buttons.forEach(button => {
      button.removeAttribute('disabled');
      button.disabled = false; // Asegura que el botón esté habilitado
    });
 
  }, 800); // 500ms delay



});